import React from 'react';
import { Card, Table, Button, Space, message, Select, Tag } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { listAgentInbox, markAgentInboxRead } from '../../api/fund';
import { formatDateTime } from '../../utils/format';

class FundAgentInbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            readFlag: '0',
            page: 1,
            pageSize: 20,
            total: 0,
            items: [],
        };
    }

    componentDidMount() {
        this.loadInbox();
    }

    loadInbox = async () => {
        const { readFlag, page, pageSize } = this.state;
        this.setState({ loading: true });
        try {
            const data = await listAgentInbox({
                readFlag: readFlag === '' ? undefined : readFlag,
                page,
                size: pageSize,
            });
            this.setState({
                items: data?.items || [],
                total: data?.total || 0,
            });
        } catch (e) {
            message.error(e.message || '加载收件箱失败');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleMarkRead = async (id) => {
        try {
            await markAgentInboxRead(id);
            message.success('已标记已读');
            await this.loadInbox();
        } catch (e) {
            message.error(e.message || '操作失败');
        }
    };

    render() {
        const { loading, readFlag, page, pageSize, total, items } = this.state;

        return (
            <Card title="消息通知" bordered={false}>
                <Space style={{ marginBottom: 16 }}>
                    <Select
                        value={readFlag}
                        style={{ width: 120 }}
                        options={[
                            { value: '0', label: '未读' },
                            { value: '1', label: '已读' },
                            { value: '', label: '全部' },
                        ]}
                        onChange={(v) => this.setState({ readFlag: v, page: 1 }, this.loadInbox)}
                    />
                    <Button icon={<ReloadOutlined />} onClick={this.loadInbox}>
                        刷新
                    </Button>
                </Space>
                <Table
                    loading={loading}
                    size="small"
                    rowKey="id"
                    scroll={{ x: 'max-content' }}
                    dataSource={items}
                    pagination={{
                        current: page,
                        pageSize,
                        total,
                        onChange: (p, ps) =>
                            this.setState({ page: p, pageSize: ps }, this.loadInbox),
                    }}
                    columns={[
                        {
                            title: '状态',
                            dataIndex: 'readFlag',
                            width: 72,
                            render: (f) =>
                                f === '1' || f === 1 ? (
                                    <Tag>已读</Tag>
                                ) : (
                                    <Tag color="blue">未读</Tag>
                                ),
                        },
                        { title: '类型', dataIndex: 'pushType', width: 120 },
                        { title: '标题', dataIndex: 'title', ellipsis: true },
                        { title: '摘要', dataIndex: 'summary', ellipsis: true },
                        {
                            title: '时间',
                            dataIndex: 'pushAt',
                            width: 160,
                            render: formatDateTime,
                        },
                        {
                            title: '操作',
                            width: 90,
                            render: (_, row) =>
                                row.readFlag !== '1' && row.readFlag !== 1 ? (
                                    <Button
                                        type="link"
                                        size="small"
                                        onClick={() => this.handleMarkRead(row.id)}
                                    >
                                        标为已读
                                    </Button>
                                ) : null,
                        },
                    ]}
                />
            </Card>
        );
    }
}

export default FundAgentInbox;
